export default __webpack_public_path__ + "static/media/noNotifications.c9040b4b.svg";